import { DISABLED_FOR_REDIRECT_PATHS } from './paths';

export const getRedirectURLFromStatus = (
    status: string,
    goto?: string | null,
    slug?: string | null,
): string => {
    let url = '';
    const isAllowedToGoTo = goto && !DISABLED_FOR_REDIRECT_PATHS.find((s) => goto.startsWith(s));
    switch (status) {
        case 'captcha':
            url = '/login/recaptcha';
            break;
        case '2fa':
            url = '/login/2fa/method';
            break;
        case '2fa-submit':
            url = '/login/2fa/submit';
            break;
        default:
            url = '';
    }
    if (url.length) {
        if (isAllowedToGoTo) {
            url += `?to=${goto}${slug ? `&${slug}` : ''}`;
        } else {
            url += `${slug ? `?${slug}` : ''}`;
        }
        return url;
    } else {
        if (isAllowedToGoTo) {
            return goto;
        }
        return '/surveys';
    }
};
